<template>
  <div class="bto-sb-element">
    <empty-state
      v-if="matchList.length === 0"
      :message="emptyStateStatusMessage"
      :iconClass="emptyStateClass" />
    <div
      v-else
      v-for="(sportId, index) in sportsWithMatches"
      :class="[
        'bto-sb-widget',
        'bto-sb-widget-prematch-us',
        widgetClass,
        getMarketClassName(sportId),
      ]"
      :key="index">
      <div
        v-if="!isCategoryList"
        class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-bg"
        :class="getSportClass(sportId)">
        <span class="bto-sb-sports-icon" :class="getSportClass(sportId)"></span>
        <h3>{{ getSportName(sportId) }}</h3>
        <router-link
          :to="getSportLink(sportId)"
          :title="t('Public.More')"
          class="bto-sb-title-more">
          {{ t("Public.More") }}
        </router-link>
      </div>
      <div
        class="bto-sb-widget-content"
        v-for="(item, index) in getTournamentList(sportId)"
        :key="index">
        <div class="bto-sb-event-odds-nav">
          <div class="bto-sb-event-odds-nav-labels">
            <div class="bto-sb-event-odds-left">
              <div class="bto-sb-event-odds-cell">{{ item[0].tournamentName }}</div>
            </div>
            <div class="bto-sb-event-odds-right">
              <div class="bto-sb-event-odds-cell">
                <span
                  class="bto-sb-event-marketlabel"
                  v-for="(market, index) in getMarketsName(item[0].sportId, item[0])"
                  :key="index">
                  {{ t(market.n) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <empty-state
          v-if="item.length === 0"
          :message="emptyStateStatusMessage"
          :iconClass="emptyStateClass" />
        <div class="bto-sb-event-odds-content" v-show="item.length > 0">
          <match-item-us
            v-for="match in item"
            :key="match.matchId"
            :item="match"
            :singleMarketView="false"
            :template="''"
            :showFirstCombo="false"
            :showSecondCombo="false"
            :is3WaySport="isThreeWay(match.sportId)"
            :firstComboOddType="{}"
            :secondComboOddType="{}"
            :showMarketsInMatch="showMarketsInMatch"
            :showEventCode="showEventCode"
            :showTeamIcon="showTeamIcon"
            :showFavorites="showFavorites"
            :showStatistics="showStatistics"
            :isLive="isLiveSport"
            :isInMatchDetails="false"
            :eventDescription="`${showCategory ? match.categoryName : ''}
          ${showCategory && showTournament ? '-' : ''}
          ${showTournament ? match.tournamentName : ''}`"
            @showCombsLeg="false" />
        </div>
        <div class="bto-sb-widget-footer" v-if="!isCategoryList">
          <router-link :to="getTournamentLink(item[0])" class="bto-sb-more-item">
            {{ t("Public.More") }} {{ item[0].tournamentName }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../../store";
  import MatchItemUs from './match-item/match-item-us.vue';
  import { EmptyState, ICON_CLASS } from '../shared/empty-state';
  import { MARKET_TYPE_IDS } from '../../models/enums/market-const';
  import { urlFriendlyParam } from '@bto-services/utils';

  export default {
    name: 'MatchListUsComponent',
    data() {
      return {
        emptyStateIcon: ICON_CLASS.HIGHLIGHTS,
        loadingSpinner: ICON_CLASS.LOADING,
        emptyStateMessage: this.t('A.NoHighlights')
      };
    },
    components: {
      EmptyState,
      MatchItemUs,
    },
    props: {
      isCategoryList: {
        type: Boolean,
        default: true,
      },
      widgetClass: {
        type: String,
        required: true,
      },
      showMarketsInMatch: {
        type: Boolean,
        default: true,
        label: 'show number of markets instead odss',
      },
      showEventCode: {
        type: Boolean,
        default: true,
        label: 'show event code',
      },
      showTeamIcon: {
        type: Boolean,
        default: false,
        label: 'show team icon',
      },
      showCategory: {
        type: Boolean,
        default: false,
        label: 'show category',
      },
      showTournament: {
        type: Boolean,
        default: false,
        label: 'show tournament',
      },
      showFavorites: {
        type: Boolean,
        default: false,
        label: 'show Favorites option',
      },
      showStatistics: {
        type: Boolean,
        default: false,
        label: 'show statistics option',
      },
      isLiveSport: {
        type: Boolean,
        default: false,
        label: 'has live matches',
      },
      isInLivesport: {
        type: Boolean,
        default: false,
        label: 'has multiple live sports',
      },
      loadingLive: {
        type: Boolean,
        default: false
      },
      matchType: {
        type: String,
        default: 'live'
      },
      isLiveFavorites: {
        type: Boolean,
        default: false,
      },
      matchList: {
        type: Array,
        required: true,
      },
      sports: {
        type: Array,
        required: true,
      },
    },
    created() {
      if (this.isLiveFavorites) {
        this.emptyStateIcon = ICON_CLASS.FAVORITES;
        this.emptyStateMessage = this.$translate.text('Mobile.NoFavoritesMessage');
        return;
      }
      if (this.isLiveSport) {
        this.emptyStateIcon = ICON_CLASS.LIVE;
        this.emptyStateMessage = this.t('Public.NoLiveMatches');
        return;
      }
    },
    computed: {
      emptyStateClass() {
        return this.loading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.loading ? this.t('Mobile.LoadingMore') : this.emptyStateMessage;
      },
      groupedMatchMap() {
        const tournamentSliceMap = {};
        return this.matchList.reduce((acc, m) => {
          if (!acc[m.sportId]) {
            acc[m.sportId] = {};
          }
          const tKey = `t_${m.tournamentId}`;
          if (!acc[m.sportId][tKey]) {
            acc[m.sportId][tKey] = [];
            tournamentSliceMap[`${m.sportId}_${tKey}`] = 0;
          }
          // Only increment the slice counter for live matches while isInLiveSport is active
          if (this.isInLivesport && this.isLiveSport) {
            tournamentSliceMap[`${m.sportId}_${tKey}`] += 1;
          }
          // Slice fixed to 3 if needed more can be done via setting
          if (tournamentSliceMap[`${m.sportId}_${tKey}`] <= 3) {
            acc[m.sportId][tKey].push(m);
          }
          return acc;
        }, {});
      },
      sportsWithMatches() {
        if (!this.sports) {
          return [];
        }
        return this.sports.filter(sid => this.groupedMatchMap[sid]);
      },
      loading() {
        let loading = true;
        switch (this.matchType) {
          case 'live':
            loading = this.loadingLive;
            break;
          case 'highlights':
            loading = store.getters.getHighlightsLoadingStatus;
            break;
          case 'upcoming':
            loading = store.getters.getUpcomingLoadingStatus;
            break;
          default:
            break;
        }
        return loading;
      },
    },
    methods: {
      getTournamentList(sportId) {
        return this.groupedMatchMap[sportId] || [];
      },
      getMarketClassName(sId) {
        let numberOfMarkets = 3;
        if (this.isThreeWay(sId)) {
          return '';
        }
        if (this.isLiveSport) {
          numberOfMarkets = Object.values(this.getTournamentList(sId))[0][0].marketsInfo.length || 1;
        } else {
          numberOfMarkets = store.getters.getSportMarketsUs(sId).length;
        }
        if (numberOfMarkets > 2) {
          return '';
        }
        return numberOfMarkets === 2 ? 'bto-sb-widget-us-two-mar' : 'bto-sb-widget-us-one-mar';
      },
      getSportClass(sId) {
        return store.getters.getSportClass(sId);
      },
      getSportName(sportId) {
        return store.getters.getSportName(sportId);
      },
      getMarketsName(sportId, item) {
        if (this.isThreeWay(sportId)) {
          return [
            { n: 'Public.Home' },
            { n: 'Public.Tie' },
            { n: 'Public.Away' },
          ];
        }
        if (this.isLiveSport) {
          return item.marketsInfo;
        }
        return store.getters.getSportMarketsUs(item.sportId);
      },
      isThreeWay(sportId) {
        let getSportType = store.getters.getSportType;
        return getSportType(sportId) === MARKET_TYPE_IDS.THREE_WAY;
      },
      getTournamentLink(match) {
        const tournament = urlFriendlyParam(match.tournamentName);
        const sport = urlFriendlyParam(match.sportName);
        const fixtureIds = `${match.tournamentId || '-'}`;
        const params = {
          sport,
          tournament,
          fixtureIds,
        };
        if (this.isLiveSport && this.isInLivesport) {
          params.tabIndex = 0;
        }
        return { name: 'seoTournament', params };
      },
      getSportLink(sportId) {
        const sportName = urlFriendlyParam(this.getSportName(sportId));
        const params = {
          sportName,
          sportId
        };

        if (this.isLiveSport && this.isInLivesport) {
          params.tabIndex = 2;
        }
        return { name: 'seoSport', params };
      },
    },
  };
</script>